<!--
  Implementation

  -in template:

  
  prop                       = explanation

-->

<template v-slot="{ open }">
  <v-expansion-panel-header class="px-4">
    <div class="d-flex align-center">
      <v-icon v-if="icon"
              v-text="icon ? icon : 'mdi-close'"
              size="20" />
      <h3 v-text="title ? title : 'No title'"
          class="mx-4 useThemeTextColor nowrapheader" />
    </div>
    <v-spacer />
    <slot name="hint">
      <span v-if="/*!open &&*/ helpertext"
            key="0"
            v-text="helpertext"
            class="helpertext"
            :class="loading ? 'blurred':''" />
    </slot>
    <template v-slot:actions>
      <v-progress-circular v-if="loading"
                           size="20"
                           width="3"
                           indeterminate
                           color="primary">
      </v-progress-circular>
    </template>
  </v-expansion-panel-header>
</template>

<script>
export default {
  name: "ExpancionHeader",
  props: ["title", "icon", "helpertext", "loading"],

  data: () => ({}),

  methods: {},

  computed: {},
};
</script>

<style lang="scss" scoped>
.helpertext {
  margin-right: 16px;
  flex-grow: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-expansion-panel--disabled .helpertext {
  margin-right: 40px;
}
</style>
